import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, concatMap, exhaustMap, map, tap } from 'rxjs';
import { UserProfileService } from 'src/app/core/services/user-profile.service';
import {
  attemptUpdateUserProfile,
  updateProfileFailure,
  updateProfileSuccess,
} from '../actions/profile-update.actions';

@Injectable()
export class ProfileUpdateEffects {
  private actions = inject(Actions);
  private usrProfileSvc = inject(UserProfileService);


  onAttemptUserProfileUpdate$ = createEffect(() =>
    { return this.actions.pipe(
      ofType(attemptUpdateUserProfile),
      concatMap(({ _id, name, phone }) =>
        this.usrProfileSvc.updateProfile(_id, name, phone).pipe(
          map(() => updateProfileSuccess({ name, phone })),
          catchError(async () =>  updateProfileFailure({  error: 'Something went wrong, please try later.'}))
        )
      )
    ) }
  );
}
